import data from './temp-aus-nz-autofill-data.json';

export function filterAutofill(str) {
  return data.filter((airport) => {
    let bool = false;
    const strRegExp = new RegExp(str.replace('(', '').replace(')', ''), 'ig');
    const suggestionTestSub = airport.suggestion.replace(/australia/ig, '').replace(/new zealand/ig, '');

    if (strRegExp.test(suggestionTestSub) || strRegExp.test(airport.cityOrAirportCode)) {
      bool = true;
    }
    return bool;
  });
}
